import { useEffect } from 'react';
import { IconButton } from '../components/IconButton';
import { IconAddCircle, IconCheck, IconSpinner } from '../components/QuirkIcons';
import { IonImg, useIonToast } from '@ionic/react';
import { Input } from '../components/Forms/Input';
import classNames from 'classnames';
import styles from './WebsiteImages.module.css';
import { useLazyGetBusinessImagesQuery } from '../api/BusinessApi.js';
import { Business } from 'model';

export interface WebsiteImagesProps {
	business: Business;
	value: string;
	onChange: (value: string) => void;
	onChangeWebsite: (value: string) => void;
	type: 'logo' | 'cover';
}

export function WebsiteImages({ onChangeWebsite, onChange, business, value, type }: WebsiteImagesProps) {
	const [trigger, data] = useLazyGetBusinessImagesQuery();

	const [showToast] = useIonToast();
	useEffect(() => {
		if (!data.isLoading) {
			if (data.error) {
				showToast({
					color: 'danger',
					message: "There was an error fetching your website's images",
					position: 'top',
					duration: 1500
				});
			} else if (data.data?.length === 0) {
				showToast({
					color: 'warning',
					message: 'No images found on your business website',
					position: 'top',
					duration: 1500
				});
			}
		}
	}, [data, showToast]);
	return (
		<div className={styles.WebsiteImages}>
			<label htmlFor="website">Find images from your business website</label>
			<div className={styles.container}>
				<Input
					value={business.website}
					onChange={evt => {
						onChangeWebsite(evt.target.value);
					}}
				/>
				<IconButton
					iconRight
					label="Get Images"
					icon={data.isLoading ? <IconSpinner size={20} flex /> : <IconAddCircle />}
					onClick={() => trigger(business)}
					disabled={data.isLoading}
					outline
				/>
			</div>
			<div className={classNames(styles.gridContainer, type === 'cover' ? styles.fullWidth : '')}>
				{!data.error &&
					data.data?.map(url => (
						<div className={styles.gridItem} onClick={() => onChange(url)} key={url}>
							{url === value && (
								<span className={styles.selectedImage}>
									<IconCheck size="large" />
								</span>
							)}
							<div className={type === 'cover' ? styles.gridItemImageFull : styles.gridItemImage}>
								<IonImg src={url} />
							</div>
						</div>
					))}
			</div>
		</div>
	);
}
